import { PlayerProperty, Save, Restore } from '../PlayerProperty';
import IPlayerData from '../../IPlayerData';
import { IPlayerState } from '../../../State/Player/IPlayerState';
import { restoreStringifiedObject } from '../../ParseHelper';
import { initialPlayerState } from 'State/Player/initialPlayerStates';

type PlayerStateKey = 'seasonPass';
type PlayerDataKeys = 'seasonPass';
export default class SeasonPass implements PlayerProperty<PlayerStateKey, PlayerDataKeys> {
    public isChanged(playerStateData: IPlayerState, playerEndpointData: IPlayerData): boolean {
        return playerEndpointData.seasonPass !== JSON.stringify(playerStateData.seasonPass);
    }

    public restore(playerEndpointData: IPlayerData): Restore<PlayerStateKey> {
        const defaultValue = initialPlayerState.seasonPass;
        const restoredString = restoreStringifiedObject(playerEndpointData.seasonPass, defaultValue);
        return restoredString ?? defaultValue;
    }

    public save(playerStateData: IPlayerState): Save<PlayerDataKeys> {
        return {
            seasonPass: JSON.stringify(playerStateData.seasonPass),
        };
    }
}
